import React from 'react'
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

import UpcominMatches from "../Match/components/UpcominMatches"


const TournamentsDetails = () => {

	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	const { language } = useSelector((state) => state.language);

	const [groups] = useState([
		{ id: 1, name: 'Group 01' },
		{ id: 2, name: 'Group 02' },
		{ id: 3, name: 'Group 03' },
		{ id: 4, name: 'Group 04' },
		{ id: 5, name: 'Group 05' },
		{ id: 6, name: 'Group 06' },
		{ id: 7, name: 'Group 07' },
		{ id: 8, name: 'Group 08' },
	]);

	const [matches] = useState([
		{ id: 1, name: 'Match 01' },
		{ id: 2, name: 'Match 02' },
		{ id: 3, name: 'Match 03' },
		{ id: 4, name: 'Match 04' },
	]);

	const [semiFinalMatches] = useState([
		{ id: 1, name: 'Match 01' },
		{ id: 2, name: 'Match 02' },
	]);

	const TeamItem = ({ teamName }) => (
		<div className="p-2 rounded-md border border-gray-400 flex justify-between items-center gap-3">
			<div className="flex gap-2 items-center">
				<div className="size-2 rounded-full bg-red-500"></div>
				<span className="font-medium">{teamName}</span>
			</div>
			<img src="/assets/images/icons/arrow-chevron-right.svg" alt="chevron" />
		</div>
	);

	const StageSection = ({ title, children }) => (
		<div className="flex gap-4 min-h-44">
			<div className="relative flex justify-center items-center before:content-[''] before:absolute before:w-full before:h-px before:bg-gray-500 before:top-2.5 before:left-1/2 after:content-[''] after:absolute after:w-full after:h-px after:bg-gray-500 after:bottom-2.5 after:left-1/2">
				<div className="absolute h-[calc(100%-20px)] w-[1px] bg-gray-500"></div>
				<span className="text-lg font-bold uppercase leading-none text-gray-800 text-nowrap rotate-180 [writing-mode:vertical-rl] bg-gray-100 py-3">
					{title}
				</span>
			</div>
			<div className="w-full flex items-center">
				<div className="w-full flex flex-wrap justify-center items-start gap-y-4 -mx-2">
					{children}
				</div>
			</div>
		</div>
	);

	const GroupCard = ({ groupName }) => (
		<div className="sm:w-1/4 w-1/2 px-2">
			<div className="space-y-3">
				<h4 className="text-base font-semibold text-gray-900 text-center">{groupName}</h4>
				<ul className="space-y-2">
					{[1, 2, 3, 4].map((teamNum) => (
						<li key={teamNum}>
							<TeamItem teamName={`Team ${String(teamNum).padStart(2, '0')}`} />
						</li>
					))}
				</ul>
			</div>
		</div>
	);

	const [activeTab, setActiveTab] = useState("tab1");
  const tabs = [
    { id: "tab1", label: t('Tournament Details') },
    { id: "tab2", label: t('Teams') },
    { id: "tab3", label: t('Fixtures') },
  ];

	return (
		<main className="main p-4 relative">
			<div className="flex flex-col">
				<div className="flex flex-wrap items-start gap-y-6 -mx-2">
					<div className="lg:w-4/6 w-full px-2">
						<div className="space-y-5">
							{/* Header Section */}
							<div className="relative text-white p-5 rounded-xl bg-gradient-to-r from-[#085EFF] to-[#044ED9] overflow-hidden">
								<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#2E4F8D] before:content-[''] before:absolute before:w-2/4 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
								<div className="relative flex max-sm:flex-wrap items-center justify-between">
									<div className="space-y-3 md:w-2/3">
										<h1 className="lg:text-3xl md:text-2xl text-xl font-bold uppercase">Rencontres de ligue 1</h1>
										<ul className="flex flex-wrap gap-2">
											<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-bold">32 Teams</li>
											<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-bold">Tournament Started at 10th November</li>
										</ul>
									</div>
									<div className="flex justify-center items-center rounded-xl border-2 border-dashed border-blue-50 bg-[#085EFF] p-5 w-48">
										<img src="assets/images/clubs/ligue1.png" alt="Ligue 1 Logo" className="max-w-56" />
									</div>
								</div>
							</div>

							<div className="">
								<ul className="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
									{tabs.map((tab) => (
										<li
											key={tab.id}
											className={`nav-item ${activeTab === tab.id
												? "active"
												: ""
												}`}
											onClick={() => setActiveTab(tab.id)}
										>
											<button>{tab.label}</button>
										</li>
									))}
								</ul>

								<div className="tab-content">
									{activeTab === "tab1" && (
										<div className="tab-pane space-y-10 p-4 rounded-xl bg-gray-50 divide-y divide-gray-300">

											<div className='flex flex-wrap gap-y-5 -mx-2'>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Tournament name</p>
													<p className='text-lg font-bold uppercase text-gray-900'>rencontres de ligue 1</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Tournament name</p>
													<p className='text-lg font-bold uppercase text-gray-900'>league / round robin</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Total Teams</p>
													<p className='text-lg font-bold uppercase text-gray-900'>32</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Rounds</p>
													<p className='text-lg font-bold uppercase text-gray-900'>5</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Start Date</p>
													<p className='text-lg font-bold uppercase text-gray-900'>10th November, 2025</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>End Date</p>
													<p className='text-lg font-bold uppercase text-gray-900'>10th November, 2025</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Venue</p>
													<p className='text-lg font-bold uppercase text-gray-900'>Stade de France, Orange Vélodrome, Groupama Stadium, Parc des Princes, Allianz Riviera</p>
												</div>
												<div className='w-1/2 px-2'>
													<p className='text-sm font-medium uppercase text-gray-400 '>Country</p>
													<div className='text-lg font-bold uppercase text-gray-900 flex items-center gap-2'>
														<div className='size-5 rounded-full overflow-hidden'>
															<img src="assets/images/flags/france.svg" alt="France" className='size-full object-cover' />
														</div>
														France
													</div>
												</div>
											</div>

											{/* Tournament Stages */}
											<div className="space-y-4 pt-10">
												{/* Group Stage */}
												<StageSection title="Group Stage">
													{groups.map((group) => (
														<GroupCard key={group.id} groupName={group.name} />
													))}
												</StageSection>

												{/* Round 03 */}
												<StageSection title="Round 03">
													{matches.map((match) => (
														<div key={match.id} className="sm:w-1/4 w-1/2 px-2">
															<div className="space-y-3">
																<h4 className="text-base font-semibold text-gray-900 text-center">{match.name}</h4>
																<ul className="space-y-2">
																	{[1, 2].map((teamNum) => (
																		<li key={teamNum}>
																			<TeamItem teamName={`Team ${teamNum}`} />
																		</li>
																	))}
																</ul>
															</div>
														</div>
													))}
												</StageSection>

												{/* Semi-final */}
												<StageSection title="Semi-final">
													{semiFinalMatches.map((match) => (
														<div key={match.id} className="sm:w-1/4 w-1/2 px-2">
															<div className="space-y-3">
																<h4 className="text-base font-semibold text-gray-900 text-center">{match.name}</h4>
																<ul className="space-y-2">
																	{[1, 2].map((teamNum) => (
																		<li key={teamNum}>
																			<TeamItem teamName={`Team ${teamNum}`} />
																		</li>
																	))}
																</ul>
															</div>
														</div>
													))}
												</StageSection>

												{/* Final */}
												<StageSection title="Final">
													<div className="sm:w-1/4 w-1/2 px-2">
														<div className="space-y-3">
															<h4 className="text-base font-semibold text-gray-900 text-center">Match 01</h4>
															<ul className="space-y-2">
																{[1, 2].map((teamNum) => (
																	<li key={teamNum}>
																		<TeamItem teamName={`Team ${teamNum}`} />
																	</li>
																))}
															</ul>
														</div>
													</div>
												</StageSection>
											</div>
										</div>
									)}
									{activeTab === "tab2" && (
										<div className="tab-pane">Teams</div>
									)}
									{activeTab === "tab3" && (
										<div className="tab-pane">Fixtures</div>
									)}
								</div>

							</div>
							
						</div>
					</div>
					<div className="lg:w-2/6 w-full px-2">
						<div className='space-y-6'>
							<div className="relative">
								<div className="relative rounded-xl bg-gray-50 h-full">
										<div className='absolute inset-0 rounded-xl overflow-hidden'>
												<div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute top-0 left-0 opacity-80"></div>
												<div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute bottom-0 right-[5vw]"></div>
												<div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute bottom-0 right-[15vw]"></div>
										</div>
										<div className="relative">
												<div className="p-5 flex flex-col items-center justify-center text-center gap-y-2">
													<button className="lg:text-2xl md:text-xl text-lg font-black uppercase flex items-center gap-2">
														<div className='size-8 p-px flex justify-center items-center rounded-full bg-gradient-to-r from-primary-950 to-primary-500'>
															<img src="assets/images/icons/plus.svg" alt="" className='icon-white' /></div>Create a match
													</button>
													<p className='text-base font-medium leading-tight text-gray-500'>Dummy text of the printing and typesetting industry.</p>
												</div>
												<div className="mx-auto md:px-10 px-5">
														<img src="assets/images/teams.png" alt="" className="w-full inline-block rounded-br-xl" />
												</div>
										</div>
								</div>
							</div>

							<UpcominMatches/>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}

export default TournamentsDetails